var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.592,
    height: 21.356,
    viewBox: "0 0 25.592 21.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bath",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4745",
    "data-name": "Group 4745",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1607",
    "data-name": "Rectangle 1607",
    width: 24.392,
    height: 3.485,
    rx: 1.742,
    transform: "translate(0 4.831)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1608",
    "data-name": "Rectangle 1608",
    d: "M0,0H22.649a0,0,0,0,1,0,0V0a9.582,9.582,0,0,1-9.582,9.582H9.582A9.582,9.582,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0.871 8.315)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M8,13.039V9.68A1.68,1.68,0,0,1,9.68,8h0a1.68,1.68,0,0,1,1.68,1.68h0",
    transform: "translate(-6.018 -8)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M46,50h0a2.519,2.519,0,0,1,2.52,2.52h0",
    transform: "translate(-28.061 -32.363)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M14.52,50h0A2.519,2.519,0,0,0,12,52.52h0",
    transform: "translate(-8.338 -32.363)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm2);
export default __webpack_public_path__ + "static/media/am2.d13ca7cf9b0c3f3f37ce650094d7c5d9.svg";
export { ForwardRef as ReactComponent };